import { NativeAuthLocalStorageSettings } from '../types';
import {
  LOCAL_STORAGE_LAST_LOGON_USERNAME_KEY,
  LOCAL_STORAGE_NATIVE_AUTH_KEY,
} from './constants';

export const getNativeAuthLocalStorageKeyByUsername = (username?: string) => {
  if (!username) {
    throw new Error('Username cannot be empty');
  }
  return `${LOCAL_STORAGE_NATIVE_AUTH_KEY}_${username}`;
};

export const getNativeAuthSettings = (
  username?: string
): NativeAuthLocalStorageSettings | null => {
  if (!username) {
    return null;
  }

  const nativeAuthSettingsString = localStorage.getItem(
    getNativeAuthLocalStorageKeyByUsername(username)
  );

  if (!nativeAuthSettingsString) {
    return null;
  }

  const nativeAuthSettings: NativeAuthLocalStorageSettings = JSON.parse(
    nativeAuthSettingsString
  );

  return nativeAuthSettings;
};

// If key does not exist, assume that it is enabled
export const isNativeAuthEnabled = (username?: string) => {
  const nativeAuthSettings = getNativeAuthSettings(username);
  return nativeAuthSettings ? nativeAuthSettings.isEnabled : true;
};

export const isNativeAuthRegistered = (username?: string) => {
  const nativeAuthSettings = getNativeAuthSettings(username);
  return nativeAuthSettings?.isRegistered ?? false;
};

export const setNativeAuthLocalStorageSettings = (
  isEnabled: boolean,
  isRegistered: boolean,
  username?: string
) => {
  if (!username) {
    return;
  }

  const nativeAuthSettings: NativeAuthLocalStorageSettings = {
    isEnabled,
    isRegistered,
  };

  localStorage.setItem(
    getNativeAuthLocalStorageKeyByUsername(username),
    JSON.stringify(nativeAuthSettings)
  );
};

export const getLastLogonUsername = () =>
  localStorage.getItem(LOCAL_STORAGE_LAST_LOGON_USERNAME_KEY) ?? undefined;

export const setLastLogonUsername = (username: string) =>
  localStorage.setItem(LOCAL_STORAGE_LAST_LOGON_USERNAME_KEY, username);
